import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const setAssetFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};
const clearAssetFormData = (state) =>{
    return {
      ...state,
      data:{}
    }
  }

const initialState = {};

export default createReducer(initialState, {
  [TYPES.SET_ASSET_FORM_DATA]: setAssetFormData,
  [TYPES.CLEAR_ASSET_FORM_DATA] : clearAssetFormData
});
